import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import benefit1 from '../../assets/images/benefit-1.png';
import benefit2 from '../../assets/images/benefit-2.png';
import benefit3 from '../../assets/images/benefit-3.png';
import benefit4 from '../../assets/images/benefit-4.png';
import floatingStories from '../../assets/images/floating-stories.png';

interface BriefInProgressProps {
  canAddMoreBriefs: boolean;
}

const benefits = [
  {
    img: benefit1,
    alt: 'Save time',
    title: 'Save Time',
    description: 'One daily email informs you of what stories are critical today',
  },
  {
    img: benefit2,
    alt: 'Be smarter',
    title: 'Be Smarter',
    description: 'Interest Scores show you how important each story is today',
  },
  {
    img: benefit3,
    alt: 'Amplify your influence',
    title: 'Amplify Your Influence',
    description: 'Share directly from your daily News Brief or Dashboard',
  },
  {
    img: benefit4,
    alt: 'Give your team an edge',
    title: 'Give your team an edge',
    description:
      'Add team members in sales or marketing, so they have a competitive info advantage',
  },
];

const BriefInProgress: FunctionComponent<BriefInProgressProps> = ({ canAddMoreBriefs }) => {
  return (
    <div>
      <div
        className="flex flex-col items-center bg-repeat-x pt-[10px] pb-[30px] text-center md:pt-[100px]"
        style={{ backgroundImage: `url(${floatingStories})`, backgroundPosition: '-50px -325px' }}
      >
        <h1 className="hidden text-[36px] text-primary-deep sm:block">
          Your News Brief will be ready soon{' '}
          <span role="img" aria-label="launch">
            🚀
          </span>
        </h1>
        <p className="mx-auto max-w-[760px] text-[24px] leading-8">
          An email notification will be sent once the report is live in your dashboard.
        </p>
        {canAddMoreBriefs && (
          <Link
            className="mt-4 mb-2 inline-block rounded border border-primary-deep bg-primary-deep px-6 py-2 text-[16px] font-medium text-white hover:no-underline hover:opacity-90"
            to="/dashboard/regular-new-report"
          >
            Create another report?
          </Link>
        )}
      </div>
      <hr className="mx-auto max-w-[1140px]" />
      <div className="mx-auto my-10">
        <h2 className="mb-8 text-center text-[28px] font-light leading-9">We want to help you:</h2>
        <div className="flex flex-row flex-wrap items-start justify-center">
          {benefits.map(benefit => (
            <div
              key={benefit.title}
              className="mb-12 flex max-w-[285px] flex-col items-center justify-center px-[15px] text-center lg:mb-0"
            >
              <img alt={benefit.alt} src={benefit.img} />
              <h3 className="text-[21px] leading-[29px] text-primary-deep">{benefit.title}</h3>
              <p className="text-[16px] leading-6">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BriefInProgress;
